import React from "react";
import ReactDOM from "react-dom/client";
import { initSentry } from "./sentry";
import App from "./App";
import { ErrorBoundary } from "./components";
import * as Sentry from "@sentry/react";

initSentry();

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ error, eventId, resetError }) => (
        <ErrorBoundary
          fullPage
          error={error as Error}
          eventId={eventId}
          onReset={resetError}
        />
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);